import React from "react";

import { translationService } from "../../../services/translation/TranslationService";
import Svg from "../../svg/Svg";
import { Success, Error } from "../../svg/svgImageList";
import { batchHighlightDetectionService } from "../../../services/batch-processing/BatchHighlightDetectionService";
import useThemeService from "../../../services/theme-service/ThemeService";
import { BatchProcessingType, StatusTableHeader, StatusTableRow } from "./StatusTableComponents";

export default function BatchHighlightDetectionStatus() {
  return (
    <section className="batch-processing-status-container">
      <h4>
        {translationService.translate("damages.BatchProcessingStatus.message", {
          itemsCount: batchHighlightDetectionService.statusModel.videoCount,
        })}
      </h4>

      <div className={"batch-processing-result-summary success"}>
        <Svg svg={Success} width={20} />
        <p className="batch-processing-summary-text success">
          {translationService.translate("damages.BatchProcessingStatus.success", {
            itemsCount: batchHighlightDetectionService.statusModel.successfullyCount,
          })}
        </p>
      </div>

      <div className={"batch-processing-result-summary error"}>
        <Svg svg={Error} width={20} />
        <p className="batch-processing-summary-text">
          {translationService.translate("damages.BatchProcessingStatus.fail", {
            itemsCount: batchHighlightDetectionService.statusModel.failedCount,
          })}
        </p>
      </div>

      <BatchHighlightDetectionStatusTable />
    </section>
  );
}

const BatchHighlightDetectionStatusTable = () => {
  const { themeClass } = useThemeService();
  return (
    <>
      <table className={themeClass(["batch-processing-status-table"])}>
        <thead>
          <StatusTableHeader />
        </thead>
        <tbody>
          <StatusTableRow batchProcessingType={BatchProcessingType.HighlightDetection}/>
        </tbody>
      </table>
    </>
  );
}
